import { createSlice } from "@reduxjs/toolkit";
const applyStore = createSlice({
    name: "list",
    initialState: {
        applyList: [],
        applyParams:{}
    },
    reducers: {
        // 添加一个todo
        setApplyList: (state, action) => {
            state.applyList = action.payload;
        },
        setApplyParams: (state, action) => {
            state.applyParams = action.payload;
        }
    }
})
const { setApplyList,setApplyParams } = applyStore.actions;
const getApplyList = (params) => {
    return (dispatch) => {
        dispatch(setApplyList(params));
    }
}
const getApplyParams = (params) => {
    return (dispatch) => {
        dispatch(setApplyParams(params));
    }
}

export { getApplyList,getApplyParams };
const reducers = applyStore.reducer;;
export default reducers;
